<template>
  <div>
    <MBUpload
      :doc-type="docType"
      @close="sendCloseMessage"
      @results="onScanResult" />
  </div>
</template>

<script>
import MBUpload from '@/mixins/MBUpload'
import iframeCommsMixin from '@/mixins/iframeCommsMixin'

export default {
  name: 'Upload',
  components: { MBUpload },
  mixins: [iframeCommsMixin],
  computed: {
    docType() {
      return this.$store.state.embedTokenData.document || ''
    }
  }
}
</script>
